export function WcmMsmGhost() {
    return null;
}
WcmMsmGhost.displayName = 'WcmMsmGhost_AEMComponent';
